const ErrorMessage = ({ className = "", children }) => {
  const errorMessageClassName = `form_error_message ${className}`.trim();

  return <span className={errorMessageClassName}>{children}</span>;
};

export default ErrorMessage;
